export default "__VITE_ASSET__BJj7Bc6g__"